import {Component, EventEmitter, input, Input, OnInit, Output} from '@angular/core';
import {CalendarModule} from "primeng/calendar";
import {FormsModule} from "@angular/forms";
import {NgIf, NgTemplateOutlet} from "@angular/common";
import {LabelWidth} from '../../../../defaults';
import {FloatLabel} from 'primeng/floatlabel';
import {DatePicker} from 'primeng/datepicker';

@Component({
  standalone: true,
  selector: 'app-datetime',
  templateUrl: './datetime.component.html',
  imports: [
    CalendarModule,
    FormsModule,
    NgIf,
    NgTemplateOutlet,
    FloatLabel,
    DatePicker
  ],
  styleUrls: ['./datetime.component.scss']
})
export class DatetimeComponent implements OnInit {

  private static inputElementCounter = 1;

  private readonly _inputElementId: number;

  get inputElementId(): string {
    return 'inputElement' + this._inputElementId;
  }

  timedDate: Date | undefined = undefined;
  _model?: Date | undefined = undefined;

  timezone = input('Europe/Rome');

  @Input()
  set model(value: Date | undefined) {
    this._model = value;
    this.updateTimedDate();
  }

  get model(): Date | undefined {
    return this._model;
  }

  @Output()
  modelChange: EventEmitter<Date | undefined> = new EventEmitter<Date | undefined>();

  @Input()
  id: string = '';

  @Input()
  showTime = true;

  @Input()
  showClear = true;

  @Input()
  placeholder = '';

  @Input()
  label = '';

  get hasLabel(): boolean {
    return this.label !== '';
  }

  @Input()
  labelWidth = LabelWidth;

  @Input()
  inputWidth = '200px';

  @Input()
  useFloatLabel: false | 'in' | 'on' | 'over' = false;

  @Input()
  useUtc = false;

  constructor() {
    this._inputElementId = ++DatetimeComponent.inputElementCounter;
  }

  ngOnInit(): void {
    // this.updateTimedDate();
  }

  onChange(dateValue: Date) {
    if (!dateValue) {
      this.modelChange.emit(undefined);
    } else {
      const resultDate = this.useUtc ? new Date(Date.UTC(
        dateValue.getFullYear(),
        dateValue.getMonth(),
        dateValue.getDate(),
        dateValue.getHours(),
        dateValue.getMinutes(),
        0)
      ) : dateValue;
      if (!this.showTime) {
        resultDate.setHours(0, 0, 0, 0); // Reset time to midnight if showTime is false
      }
      this.modelChange.emit(resultDate);
    }
  }

  private updateTimedDate() {
    this.timedDate = this.model
      ? (this.useUtc
        ? new Date(this.model.getUTCFullYear(),
          this.model.getUTCMonth(),
          this.model.getUTCDate(),
          this.model.getUTCHours(),
          this.model.getUTCMinutes(),
          0
        )
        : this.model)
      : undefined;
  }

}
